import { formatToTwoDigits } from './formatStringHelpers';

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const timeFormatter = (left: number): string => {
	const addingZero = (time: number): string => String(time).padStart(2, '0');
	const minutes = addingZero(Math.floor(left / 60));
	const seconds = addingZero(left % 60);
	return `${minutes}:${seconds}`;
};

export const differenceInDaysHandler = (dateString: string) => {
	if (!dateString) return 0;
	
	const msPerDay = 1000 * 60 * 60 * 24;

	const currentDayMs = new Date().getTime();
	const prevDayMs = new Date(dateString).getTime();
	const timeDifference = currentDayMs - prevDayMs;

	return timeDifference < 0 ? 0 : Math.floor( timeDifference / msPerDay);
};

const datePartsHandler = (date: string | number) => {
	const dateObj = new Date(date);

	const seconds = dateObj.getSeconds();
	const minutes = dateObj.getMinutes();
	const hours = dateObj.getHours();
	const day = dateObj.getDate();
	const month = monthNames[dateObj.getMonth()];
	const year = dateObj.getFullYear();

	return { seconds, minutes, hours, day, month, year };
};

export const utcDatePartsHandler = (date: string, time: string) => {
	const dateObj = new Date(date.concat(time));

	const seconds = dateObj.getUTCSeconds().toString().padStart(2, '0');
	const minutes = dateObj.getUTCMinutes().toString().padStart(2, '0');
	const hours = dateObj.getUTCHours().toString().padStart(2, '0');
	const day = dateObj.getUTCDate().toString().padStart(2, '0');
	const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
	const year = dateObj.getUTCFullYear().toString();

	return { seconds, minutes, hours, day, month, year };
};

const amPmHourHandler = (hours: number) => {
	const ampm = hours >= 12 ? 'PM' : 'AM';
	const hoursAmPm = hours % 12;
	const displayHours = hoursAmPm ? hoursAmPm : 12;

	return { ampm, displayHours };
};

export const getHoursFromSeconds = (seconds: number) => Math.floor(seconds / 3600);

export const getMinutesFromSeconds = (seconds: number) => Math.floor((seconds % 3600) / 60);

export const secondsToDays = (seconds: number) => Math.floor(seconds / (3600 * 24));

export const secondsToHours = (seconds: number) => Math.floor((seconds % (3600 * 24)) / 3600);

export const secondsToMinutes = (seconds: number) => Math.floor((seconds % 3600) / 60);

export const roundSeconds = (seconds: number) => Math.floor(seconds);

export const activityInMinutesHandler = (time: string) => {
	const minutes = parseInt(time);

	if (minutes < 2) return '1 minute';

	return `${minutes} minutes`;
};

/*Helper to Generate Date with Format 5 months*/

export const monthsSuffixHandler = (numMonths: number) => {
	return numMonths > 1 ? 'months' : 'month'
};

/*Helper to Generate Date with Format 01 Jan 2020*/

export const shortDateHandler = (date: string | number) => {
	if (!date) return '-';

	const { day, month, year } = datePartsHandler(date);
	return `${formatToTwoDigits(day)} ${month} ${year}`;
};

/*Helper to Generate Date with Format 09 Jul 2020, 06:08 AM*/

export const longDateHandler = (date: string | number) => {
	if (!date) return '-';

	const { minutes, hours, day, month, year } = datePartsHandler(date);
	const { ampm, displayHours } = amPmHourHandler(hours);

	return `${formatToTwoDigits(day)} ${month} ${year}, ${formatToTwoDigits(displayHours)}:${formatToTwoDigits(
		minutes,
	)} ${ampm}`;
};

export const longDateHandlerWithSeconds = (date: string | number) => {
	if (!date) return '-';

	const { seconds, minutes, hours, day, month, year } = datePartsHandler(date);
	const { ampm, displayHours } = amPmHourHandler(hours);

	return `${formatToTwoDigits(day)} ${month} ${year}, ${formatToTwoDigits(displayHours)}:${formatToTwoDigits(
		minutes,
	)}:${formatToTwoDigits(seconds)} ${ampm}`;
};

/*Returns string in Format 31 Jan 2020, 01:45 PM - 02:55 PM*/

export const dateDifStringHandler = (start: string, end: string) => {
	const timeWithPM = (time: Date) => {
		const hours = time.getHours();
		const minutes = time.getMinutes();
		const hoursInAmPm = hours % 12;

		const amPm = hours >= 12 ? 'PM' : 'AM';
		return `${hoursInAmPm ? hoursInAmPm : 12}:${minutes < 10 ? `0${minutes}` : minutes} ${amPm}`;
	};
	const startDate = new Date(start);
	const endDate = new Date(end);
	if (!startDate || !endDate) return '-';
	const date = startDate.getDate();
	const month = startDate.getMonth();
	const year = startDate.getFullYear();

	return `${date} ${monthNames[month]} ${year}, ${timeWithPM(startDate)} - ${timeWithPM(endDate)}`;
};

export const sessionDurationHandler = (minutes: number) => {
	const minutsInHour = 60;
	if (minutes < minutsInHour) return `${minutes} min`;

	const hours = Math.floor(minutes / minutsInHour);
	const leftMinutes = minutes - minutsInHour * hours;
	return `${hours}h ${leftMinutes}m`;
};

export const shiftDateOnDays = (days: number) => {
	const date = new Date();
	
	date.setDate(date.getDate() - days);

	return date;
}
